@if (showInModal) {
  <div class="list-group">
    <a [href]="linkGoogle" class="list-group-item list-group-item-action " target="_blank">
      <img src="assets/img/icons/google-calendar.svg" width="22" height="22" />
      Google Calendar
    </a>
    <!-- <a class="list-group-item list-group-item-action" (click)="openICalendar()" style="cursor:pointer">
    <img src="assets/img/icons/ical-icon.svg" width="22" height="22" />
    iCal
  </a> -->
  <a [href]="linkOutlook" class="list-group-item list-group-item-action" target="_blank">
    <img src="assets/img/icons/outlook-icon.svg" width="22" height="22" />
    Outlook
  </a>
</div>
}
@if (!showInModal) {
  <div class="row justify-content-end mr-1">
    <a [href]="linkGoogle" target="_blank" class="mx-1">
      <img src="assets/img/icons/google-calendar.svg" width="18" height="18" />
    </a>
    <a [href]="linkOutlook" target="_blank" class="mx-1 mr-1">
      <img src="assets/img/icons/outlook-icon.svg" width="18" height="18" />
    </a>
  </div>
}

